<template>
  <div class="login-container">
    <template v-if="isLoggedIn">
      <div class="logged-in-tip">已登录</div>
      <button class="login-btn" @click="handleLogout">退出登录</button>
    </template>
    <template v-else>
      <div class="form-item">
        <label>用户名</label>
        <input v-model="username" type="text" placeholder="请输入账号" />
      </div>
      <div class="form-item">
        <label>密码</label>
        <input v-model="password" type="password" placeholder="请输入密码" />
      </div>
      <button class="login-btn" @click="handleLogin">登录</button>
    </template>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import request from '@/utils/request'
import { notify } from '@/utils/notify'
import { encryptPwd } from "@/utils/loginUtil"

const router = useRouter()
const username = ref('')
const password = ref('')
const isLoggedIn = ref(!!localStorage.getItem('token'))

const handleLogin = async () => {
  if (!username.value || !password.value) {
    notify.warning('请输入用户名和密码')
    return
  }
  try {
    const res = await request.post('/login', {
      account: username.value,
      password: encryptPwd(password.value, '123ABCLY')
    })
    localStorage.setItem('token', res.data.data.token)
    isLoggedIn.value = true
    notify.success('登录成功')
    router.push('/download')
  } catch (err) {
    console.error(err)
  }
}

const handleLogout = () => {
  localStorage.removeItem('token')
  isLoggedIn.value = false
  notify.success('已退出登录')
}
</script>
<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-item label {
  font-size: 14px;
  color: #333;
}

.form-item input {
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: none;
}

.logged-in-tip {
  text-align: center;
  font-size: 18px;
  color: #00b42a;
  font-weight: 500;
  padding: 30px 0;
}

.login-btn {
  height: 44px;
  background-color: #1677ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}
</style>
